import React from 'react';
import './detallerubro.css';
import { rubros } from '../../json/rubros';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

const wololoo=(formato,urlXLSX)=>{
  if(formato.nombre === "Tiempos Oficiales"){
    urlXLSX="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx";
    return urlXLSX
}else if(formato.nombre === "Información Relacionada a Tiempos Oficiales") {
  urlXLSX="http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/xlsx/a69_f23_d.xlsx";
    return urlXLSX
}else if(formato.nombre === "Índice de Expedientes Clasificados") {
  urlXLSX="https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx";
    return urlXLSX
}





/*else if(formato.nombre === ""){
  urlXLSX="";
  return urlXLSX
}*/
else{
  return urlXLSX
}
}
const aiesh=(formato,urlHTML)=>{
  if(formato.nombre === "Tiempos Oficiales"){
    urlHTML="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm";
    return urlHTML
}else if(formato.nombre === "Información Relacionada a Tiempos Oficiales") {
  urlHTML="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/htm/a69_f23_d_RTVH.htm";
    return urlHTML


}else if(formato.nombre === "Índice de Expedientes Clasificados") {
  urlHTML="https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm";
    return urlHTML



}

/*else if(formato.nombre === ""){
  urlHTML="";
  return urlHTML
}*/
else{
  return urlHTML
}
}
const DetalleRubro = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nombre } = useParams();
  const rubro = rubros.find((rubro) => rubro.nombre === nombre);

  return (
    <div className='container container_detalle_rubro'>
      <div className='row'>
        <div className='col-12'>
        <br></br>   <br></br>
          <div className='rubro_titulo'>
            <h3 className='title'>{rubro.nombre}</h3>
            <hr className='hr-gob' />
          </div>
        </div>
      </div>
      <div className='row'>
        {
          rubro.formatos.map((formato, index) => {
            const urlXLSX = "/Transparencia/xlsx/a69" + formato.xlsx + "SEGOB.xlsx";
            const urlHTML = "/Transparencia/htm/a69" + formato.html + "SEGOB.htm";

            
            
            return (
              <div key={ index } className='col-md-4 col-12'>
                <div className='rubro_container_detalle'>
                  <div className='detalle_rubro_nombre'>
                    <h5>{ formato.nombre }</h5>
                  </div>
                  
                  <div className='detalle_rubro_enlaces'>
                  
                    <a href={ wololoo(formato, urlXLSX) } target="_blank">XLSX</a>
                    <a href={ aiesh(formato, urlHTML) } target="_blank">Ver Tabla</a>
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

export default DetalleRubro;
